/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_BicInputs */

const de__field_bic = /** @type {(inputs: _Field_BicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BIC`)
};

/**

* @param {_Field_BicInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_bic = /** @type {((inputs?: _Field_BicInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_BicInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_bic(inputs)
});